import moment from "moment";
import Vue from "vue";
import { getStationSampleDevice } from "@/api/api";
import { GetRequest } from "@/utils/utils";
import windowContent from "@/components/windowContent";
// 获取vue实例
let vm = null;
const getInstance = e => {
  vm = e;
};

// iframe高度自适应
/* function setHeight(iframe) {
        if (iframe) {
            var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow;
            if (iframeWin.document.body) {
                iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
            }
        }
    };
    window.onload = function () {
    setIframeHeight(document.getElementById('external-frame'));
}; */

// 弹窗
async function openStationWindow({
  map,
  point,
  groups,
  station,
  timeType,
  dataType,
  showChilds,
  valueTime,
  calied_type,
  loadSnapStatus
}) {
  const type = timeType === "real" ? "min" : timeType;
  const isProd = process.env.NODE_ENV === "production";
  const host = !isProd
    ? `${location.protocol}//${GetRequest("host") || location.host}`
    : "";
  let url = `${host}/yangchen_station/?station_id=${station.station_id}&groups=${groups}&showMap=0&timep=${type}&data_type=${dataType}&t=${station.time}&show_childs=${showChilds}&data_calied_type=${calied_type}&show_compare=0`;
  if (!loadSnapStatus) {
    url += `&start=${moment(valueTime[0]).unix()}&end=${moment(
      valueTime[1]
    ).unix()}`;
  }
  url += `&title_link=0&select_back=near1,near3,near5`;
  let iframe =
    `<iframe id="external-frame" width="100%" height="600px" src="` +
    url +
    `" frameborder="0"></iframe>`;
  let showSampleDevice = false;
  let sampleDevice_data = null;

  await getStationSampleDevice(station.name)
    .then(r => {
      if (JSON.stringify(r.data) !== "{}") {
        sampleDevice_data = r.data;
        showSampleDevice = true;
      }
    })
    .catch(e => {
      console.log(e);
      showSampleDevice = false;
    });

  console.log(showSampleDevice);
  // let content = `
  //       <div class="panel panel-primary" style="position: relative">
  //           ${iframe}

  //       </div>`;

  let myComponent = Vue.extend({
    render: h =>
      h(windowContent, {
        props: {
          iframeUrl: url,
          showSampleDevice: showSampleDevice,
          sampleDevice_data: sampleDevice_data,
          stationName: station.name
        }
      })
  });
  let baseCom = new myComponent().$mount();
  let infoWindow = new BMap.InfoWindow(baseCom.$el, {
    width: 570,
    height: showSampleDevice ? 650 : 560
  });
  infoWindow.addEventListener("close", () => {});
  map.openInfoWindow(infoWindow, point);
  // setTimeout(() => {
  //   document.getElementsByClassName(
  //     "BMap_bubble_content"
  //   )[0].parentElement.style.overflow = "auto";
  // }, 1000);
}

function showGfStationInfo(map, e) {
  console.log("INFO", e);
  var opts = {
    width: 200,
    height: 280,
    title: '<strong style={align:"center"}>水质情况</strong>'
  };

  var markInfo = "";
  markInfo += "标站：" + e.station.station + "<br/>";
  markInfo += "SN：" + e.station.sn + "<br/>";
  markInfo += "经度：" + e.station.lng + "<br/>";
  markInfo += "纬度：" + e.station.lat + "<br/>";
  markInfo +=
    "CODcr：" + `${e.station.cod_cr ? e.station.cod_cr : "--"}` + "<br/>";
  markInfo += "CODmn：" + `${e.count ? e.count : "--"}` + "<br/>";
  markInfo +=
    "氨氮：" +
    `${e.station.ammonia_nitrogen ? e.station.ammonia_nitrogen : "--"}` +
    "<br/>";
  markInfo +=
    "浊度：" + `${e.station.turbidity ? e.station.turbidity : "--"}` + "<br/>";
  markInfo +=
    "电导率：" +
    `${e.station.conductivity ? e.station.conductivity : "--"}` +
    "<br/>";
  markInfo += "PH：" + `${e.station.ph ? e.station.ph : "--"}` + "<br/>";
  markInfo +=
    "水温：" +
    `${e.station.water_temperature ? e.station.water_temperature : "--"}` +
    "<br/>";
  markInfo +=
    "时间：" +
    moment.unix(e.station.data_time).format("YYYY-MM-DD HH:mm:ss") +
    "<br/>";

  var point = new BMap.Point(e.station.lng, e.station.lat);
  var infoWindow = new BMap.InfoWindow(markInfo, opts);
  map.openInfoWindow(infoWindow, point);
}

export { openStationWindow, getInstance, showGfStationInfo };
